module.exports = __webpack_public_path__ + "static/img/qingqu3.92d5d74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/qqly/qingqu3.jpg
// module id = FVxg
// module chunks = 0